export const SCROLL_BARRIER = 1600;
export const phoneNumber = '+40 747 057 615';
export const oasisEmail = 'contact@oasisresidence.co';
